import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { AboutHero } from './about/AboutHero';
import { MasterJoeSection } from './about/MasterJoeSection';
import { BehindTheVision } from './about/BehindTheVision';
import { InstructorsSection } from './about/InstructorsSection';
import { AboutCTA } from './about/AboutCTA';
export function AboutPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-280">
      <Navigation data-id="element-281" />
      <AboutHero data-id="element-282" />
      <MasterJoeSection data-id="element-283" />
      <BehindTheVision data-id="element-284" />
      <InstructorsSection data-id="element-285" />
      <AboutCTA data-id="element-286" />
      <TrialOfferCTA data-id="element-287" />
      <Footer data-id="element-288" />
    </div>;
}